export const placeTaxonomyMappedFieldTypes = {
  TYPE: 'Type',
  REGION: 'Region',
  PLACE_ACCESSIBILITY: 'PlaceAccessibility',
};
